import React, { useEffect, useRef, useState } from "react";
import "../Login/Login.scss";
import FormInputField from "../../components/UserFormComponents/FormInputField/FormInputField";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/CustomButton";
import { loginWithGoogle, register as registerUser } from "../../api/auth";
import { toast } from "react-toastify";
import ROUTES from "../../constants/routes";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { updateUser, updateUserToken } from "../../redux/features/user-slice";
import DesktopLoginContents from "../../components/DesktopLoginContents/DesktopLoginContents";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { Capacitor } from "@capacitor/core";
import Captcha from "../../components/Captcha/Captcha";
import { storage } from "../../helpers/storage";

const Register = ({ setLoadingUser }) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let gotoPath = null;

  const getGotoPath = async () => {
    gotoPath = (await storage.get("gotoPath")) || null;
  };

  const user = useSelector((state) => state.userReducer.value);

  const aggreeWatch = watch("agree");

  const [submitting, setSubmitting] = useState(false);
  const reRef = useRef(null);

  useEffect(() => {
    getGotoPath();
    if (user.token) {
      if (gotoPath) {
        navigate(gotoPath);
      } else {
        navigate(ROUTES.home.path);
      }
    }
  }, []);

  const handleRegister = async (data) => {
    if (data?.agree) {
      if (data?.password === data?.confirmPassword) {
        setSubmitting(true);
        let captchaToken = "";
        let source = "";
        if (Capacitor.isNativePlatform()) {
          source = "mobile";
        } else {
          captchaToken = await reRef.current.executeAsync();
        }
        const name = `${data?.email}`.split("@")[0];
        const credentials = {
          name: name,
          email: data?.email,
          password: data?.password,
          remember_me: data?.remember_me,
          is_add_user: false,
          captchaToken: captchaToken,
          source: source,
        };
        registerUser(credentials)
          .then((res) => {
            storage.remove("cart");
            if (res.data.data?.id) {
              toast.dismiss();
              toast.success(
                "Register successfull, please enter the OTP that is sent to your email address."
              );
              navigate(ROUTES.verifyOTP.path, {
                state: {
                  userVerify: true,
                  email: credentials.email,
                  phone: null,
                  resendTimer: res.data?.resend_timer || 60,
                  gotoPath: gotoPath,
                },
              });
            } else {
              toast.dismiss();
              toast.error("Registration failed!");
            }
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.errors) {
                if (err?.response?.data?.errors?.name) {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.errors?.name}`);
                } else if (err?.response?.data?.errors?.email) {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.errors?.email}`);
                } else if (err?.response?.data?.errors?.password) {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.errors?.password}`);
                } else {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.message}`);
                }
              } else {
                toast.dismiss();
                toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss();
              toast.error("Registration failed!");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        setError("confirmPassword", {
          type: "custom",
          message: "Confirm password doesnot match with above password!",
        });
      }
    }
  };

  const apiGoogleRegister = (credentials) => {
    setLoadingUser(true);
    loginWithGoogle(credentials)
      .then((res) => {
        storage.remove("cart");
        if (res.data.user) {
          dispatch(updateUser(res.data.user));
          storage.set("userData", JSON.stringify(res.data.user));
        }
        if (res.data?.expires_at) {
          storage.set("expiresAt", res.data.expires_at);
        }
        if (res.data.token) {
          const tokenData = {
            token: res.data.token,
          };
          dispatch(updateUserToken(tokenData));
          storage.set("authToken", JSON.stringify(res.data.token));
          if (gotoPath) {
            navigate(gotoPath);
          } else {
            navigate(ROUTES.home.path);
          }
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.dismiss();
          toast.error(err?.response?.data?.message);
        } else {
          toast.dismiss();
          toast.error("Google registration failed!");
        }
      })
      .finally(() => {
        setSubmitting(false);
        setLoadingUser(false);
      });
  };

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      GoogleAuth.initialize();
    }
  }, []);

  const handleGoogleRegister = () => {
    if (Capacitor.isNativePlatform()) {
      googleAppRegister();
    } else {
      googleWebRegister();
    }
  };

  const googleAppRegister = () => {
    GoogleAuth.signIn()
      .then((result) => {
        if (result.authentication?.accessToken) {
          setSubmitting(true);
          const credentials = {
            access_token: result.authentication?.accessToken,
            source: "mobile",
          };
          apiGoogleRegister(credentials);
        }
      })
      .catch((err) => {
        toast.dismiss();
        toast.error("Google registration failed!");
      });
  };

  const googleWebRegister = useGoogleLogin({
    onSuccess: async (response) => {
      if (response?.access_token) {
        setSubmitting(true);
        const captchaToken = await reRef.current.executeAsync();
        const credentials = {
          access_token: response.access_token,
          captchaToken: captchaToken,
        };

        apiGoogleRegister(credentials);
      }
    },
    onError: (error) => {
      toast.dismiss();
      toast.error("Google registration failed!");
    },
  });
  return (
    <>
      <Captcha reRef={reRef} />
      <div className="initial-page-contents">
        <div className="login-page">
          <div className="form-container">
            <div className="heading">
              <p className="title">
                Hello <br />
                <span>there!</span>
              </p>
              <p className="message">
                Create an account to access to your product details and get
                real-time updates on your products.
              </p>
            </div>
            <form onSubmit={handleSubmit(handleRegister)}>
              <div className="inputs">
                <FormInputField
                  name={"email"}
                  label={"Enter your mail/phone number"}
                  type={"email"}
                  iconType={"email"}
                  register={register}
                  watch={watch}
                  required={true}
                  inputErrors={errors}
                />
                <FormInputField
                  name={"password"}
                  label={"Create password"}
                  type={"password"}
                  iconType={"password"}
                  required={true}
                  watch={watch}
                  register={register}
                  inputErrors={errors}
                  constraints={{
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                  }}
                />
                <FormInputField
                  name={"confirmPassword"}
                  label={"Re-type your password"}
                  type={"password"}
                  iconType={"password"}
                  required={true}
                  watch={watch}
                  register={register}
                  inputErrors={errors}
                  constraints={{
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                  }}
                />
              </div>

              <div className="forgot-container">
                <div className="remember-me">
                  <label>
                    <input type="checkbox" {...register("agree")} />
                    <span class="checkbox-container"></span>
                  </label>
                  <p className="label" style={{ lineHeight: "" }}>
                    By Signing up, you agree to our{" "}
                    <Link to={"#"}>Terms of Service</Link> and{" "}
                    <Link to={"#"}>Privacy Policy</Link>
                  </p>
                </div>
              </div>

              <CustomButton
                name={"Sign Up"}
                type={"submit"}
                color={"white"}
                bigButton={true}
                disabled={submitting || !aggreeWatch}
                handleSubmit={() => {}}
                loader={submitting}
              />

              <div className="hr-container">
                <span></span>
                <p>Or</p>
              </div>

              <button
                className="google-button"
                type="button"
                onClick={() => {
                  if (aggreeWatch) {
                    handleGoogleRegister();
                  }
                }}
                disabled={submitting || !aggreeWatch}
              >
                <img
                  src="/images/google.svg"
                  alt=""
                  aria-label="Register With Google"
                />
                Sign up with google
              </button>

              <div className="register-link">
                <p>Already have an account?</p>
                <Link to={ROUTES.login.path}>Sign In</Link>
              </div>
            </form>
            <p className="company-tag">
              &copy; Daikofin <span></span>
              <Link to={ROUTES.contactDUS.path}>Contact</Link>
              <span></span>
              <a href={"https://daikoapp.com/index.php/73-2/"} target="blank">
                Privacy & terms
              </a>
            </p>
          </div>
        </div>
        <DesktopLoginContents />
      </div>
    </>
  );
};

export default Register;
